export default {
  svgPath: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.9779 9L18 9V11H10.9779V18H8.9779L8.97791 11H2L2 9L8.97791 9L8.97791 2L10.9779 2V9Z"/>
  `,
  title: 'Plus',
  viewBox: '0 0 20 20',
};
